<template>
	<div class="row">
		<div class="col-sm-12 col-md-12 col-lg-12">
			<div class="login">
				<div class="row row-form">
					<div class="col-sm-12">
						<div class="signup__header">
							<h2>{{ $t('signup') }}</h2>
						</div>
						<div class="signup">
							<input
								:class="'textInput login_input-top-radius' + (errorMessages['emailErrorMessages'] ? ' error': '')"
								name="email" type="text" id="email" v-model="login"
								:placeholder="$t('email')">
							<span class="error" v-if="errorMessages['emailErrorMessages']">
							  {{$t(errorMessages['emailErrorMessages']) || errorMessages['emailErrorMessages']}}
							</span>
							<input
								:class="'textInput signup_input' + (errorMessages['passwordErrorMessages'] ? ' error': '')"
								name="password" type="password" id="pass" v-model="pass"
								:placeholder="$t('password')">
							<span class="error" v-if="errorMessages['passwordErrorMessages']">
							  {{$t(errorMessages['passwordErrorMessages']) || errorMessages['passwordErrorMessages']}}
							</span>
							<input
								:class="'textInput signup_input' + (errorMessages['firstNameErrorMessages'] ? ' error': '')"
								name="first_name" type="text" id="firstName" v-model="firstName"
								:placeholder="$t('first.name')">
							<span class="error" v-if="errorMessages['firstNameErrorMessages']">
							  {{$t(errorMessages['firstNameErrorMessages']) || errorMessages['firstNameErrorMessages']}}
							</span>
							<input
								:class="'textInput signup_input' + (errorMessages['lastNameErrorMessages'] ? ' error': '')"
								name="last_name" type="text" id="lastName" v-model="lastName"
								:placeholder="$t('last.name')">
							<span class="error" v-if="errorMessages['lastNameErrorMessages']">
							  {{$t(errorMessages['lastNameErrorMessages']) || errorMessages['lastNameErrorMessages']}}
							</span>
							<select name="country"
									:class="'select login_input-bottom-radius' + (errorMessages['countryErrorMessages'] ? ' error': '')"
									id="country" v-model="country">
								<option v-for="(value, key) in countries" :key="key" :value="key">{{
									$t(value) }}
								</option>
							</select>
							<span class="error" v-if="errorMessages['countryErrorMessages']">
							  {{$t(errorMessages['countryErrorMessages']) || errorMessages['countryErrorMessages']}}
							</span>
							<div class="signup__agree">
								<p>{{ $t('click.agree') }} <a class="auth-link" target="_blank"
																			 href="agreement">{{
									$t('agree') }}</a></p>
							</div>
							<button type="button" @click="signUp"
									:class="(valid ? 'signup_button-login' : 'signup_button-disabled')"
									id="signup-password-button" :disabled="(!valid)">{{$t('signup')}}
							</button>
						</div>
						<div class="signup__footer">
							<div class="row">
								<div class="col-xs-7">
									<p>{{ $t('have.an.account') }}
										<a class="link auth-link" href="login">{{ $t('log.in') }}</a>
									</p>
								</div>
								<div class="col-xs-5">
									<Languages/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import http from 'utils/http'
import Languages from 'components/languages-switch/Languages'

export default {
	name: 'Signup',
	metaInfo: {
		title: 'Signup'
	},
	components: {
		Languages
	},
	data () {
		return {
			data: [],
			login: '',
			pass: '',
			firstName: '',
			lastName: '',
			country: 'EE',
			errorMessages: {},
			countries: []
		}
	},
	computed: {
		valid: function () {
			return this.login !== '' && this.pass !== '' && this.firstName !== '' && this.lastName !== ''
		}
	},
	methods: {
		signUp: function () {
			let then = this
			let data = {
				login: this.login,
				password: this.pass,
				first_name: this.firstName,
				last_name: this.lastName,
				country: this.country
			}
			if (this.valid) {
				http.post('auth/signup', data)
					.then(function (response) {
						then.$router.push('/confirm-email-submission?email=' + data.login)
					})
					.catch(function (error) {
						then.clearErrorMessages()
						then.validationMessages(error.response.data)
						console.log(error.response.data)
					})
			}
		},
		validationMessages: function (errors) {
			let then = this
			let allErrors = {
				'login.should.be.specified': 'loginErrorMessages',
				'incorrect.email.address': 'emailErrorMessages',
				'first.name.should.be.specified': 'firstNameErrorMessages',
				'incorrect.first.name.length': 'firstNameErrorMessages',
				'last.name.should.be.specified': 'lastNameErrorMessages',
				'incorrect.last.name.length': 'lastNameErrorMessages',
				'password.should.be.specified': 'passwordErrorMessages',
				'incorrect.password.length': 'passwordErrorMessages',
				'country.should.be.specified': 'countryErrorMessages',
				'person.with.specified.login.already.exists': 'emailErrorMessages',
			}

			if (typeof errors === 'object') {
				errors.forEach(function (value) {
					then.errorMessages[allErrors[value]] = value
				})
			}
			if (typeof errors === 'string') {
				then.errorMessages[allErrors[errors]] = errors
			}
		},
		clearErrorMessages: function () {
			this.errorMessages = {}
		}
	},
	mounted () {
		http.get('/countries')
			.then((resp) => {
				this.countries = resp.data
			})
	}
}
</script>

<style scoped>

</style>
